import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InvestigationsApi } from '../api/investigations.api';
import { switchMap, map } from 'rxjs/operators';

import { InvestigationData, Investigation } from '../../../interfaces/masters/investigations' ;
@Injectable()
export class InvestigationService extends InvestigationData {

    constructor(private api: InvestigationsApi) {
      super();
    }
  
  
    list(url: string): Observable<Investigation[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<Investigation>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Investigation): Observable<Investigation[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Investigation): Observable<Investigation> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  